// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import {
  scrubBreadcrumb,
  scrubEvent,
} from './src/common/utils/monitoring/sentryScrubbing';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_APP_STAGE,
  tracesSampleRate: 1.0,
  beforeBreadcrumb: scrubBreadcrumb,
});

// beforeSend skips transactions, so the page URL is scrubbed here instead.
Sentry.addGlobalEventProcessor(scrubEvent);
